import * as PIXI from 'pixi.js';
import {Container} from "./Container";
import {LibraryFlump} from "../library/LibraryFlump";
import {GameObject} from "../../base/GameObject";

export class Checkbox extends Container {

  public payload = '';

  protected _checkFunction: Function | null = null;
  protected _bg: PIXI.Container | null = null;
  protected _check: PIXI.Container | null = null;
  protected _initialScale = 0;
  protected _isDown = false;
  protected _isSelected = false;
  protected _isEnabled = true;

  public get isSelected() {
    return this._isSelected;
  }

  public set isSelected(value: boolean) {
    if (this._isSelected == value) {
      return;
    }
    this._isSelected = value;
    this._check!.visible = this._isSelected;
  }

  public set checkCallback(value: Function) {
    if (!this.destroyed) {
      if (value) {
        this.interactive = true;
        this.interactiveChildren = true;
        this._bg!.interactive = true;
        this._check!.interactive = true;
        this._checkFunction = value;
        this.addClickListener();
      } else {
        this.interactiveChildren = false;
        this.interactive = false;
        this._bg!.interactive = false;
        this._check!.interactive = false;
        this._checkFunction = null;
        this.removeClickListener();
      }
    }
  }

  get isEnabled(): boolean {
    return this._isEnabled;
  }

  set isEnabled(value: boolean) {
    if (this._isEnabled !== value) {
      this._isEnabled = value;
      this.interactive = value;
      this.alpha = value ? 1 : 0.5;
    }
  }

  override build() {
    super.build();
    this._bg = this.getChildByLabel(LibraryFlump.FLUMP_BOX);
    this._check = this.getChildByLabel(LibraryFlump.FLUMP_CHECK);
    this._check!.visible = false;
  }

  override destroy(): void {
    this.removeClickListener();
    this._bg = GameObject.destroy(this._bg);
    this._check = GameObject.destroy(this._check);
    super.destroy();
  }

  protected addClickListener(): void {
    this.on('pointerdown', this.onTouched, this);
    this.on('pointerup', this.onTouched, this);
    this.on('pointertap', this.onTap, this);
    this.on('pointerupoutside', this.onTouched, this);
  }

  protected removeClickListener(): void {
    this.off('pointerdown', this.onTouched, this);
    this.off('pointerup', this.onTouched, this);
    this.off('pointertap', this.onTap, this);
    this.off('pointerupoutside', this.onTouched, this);
  }

  protected onTouched(event: PIXI.FederatedPointerEvent): void {
    if (!this._isEnabled) {
      return;
    }
    const touch = event.global;
    if (event.type === 'pointerdown' && !this._isDown) {
      this._isDown = true;
      this.onTouch();
    } else if (this._isDown) {
      this._isDown = false;
      this.onUnTouch();
    }
  }

  protected onTap(event: PIXI.FederatedPointerEvent): void {
    this.changeState();
  }

  protected onTouch(): void {
    if (!this._initialScale) {
      this._initialScale = this._bg!.scale.y;
    }
    this.stopPulsating();
    this._bg!.scale = this._initialScale * 0.85;
  }

  protected onUnTouch(): void {
    this._bg!.scale = this._initialScale;
  }

  protected changeState(): void {
    this.isSelected = !this.isSelected;
    if (this._checkFunction) {
      if (this._checkFunction.length) {
        this._checkFunction(this);
      } else {
        this._checkFunction();
      }
    }
  }
}
